import classNames from 'classnames'
import './index.css'
import React from 'react'
import useIsMediumScreen from 'hooks/use-is-medium-screen'
import isInformationValidGiftSelect from 'modules/gift/redux/selectors/is-information-valid'
import useSelector from 'hooks/use-selector'
import useDispatch from 'hooks/use-dispatch'
// import { throttle } from 'lodash'
import logUtil from 'utils/log'
// import getYOffsetDomUtil from 'utils/dom/get-y-offset'
import handleResizePositionFixedComponentUtil from 'utils/component/handle-resize-position-fixed'
import View from 'components/View'
// import GiftingModeBanner from 'pages/Gift/components/GiftingModeBanner/containers/Banner'
// import Flex from 'components/Flex'
import getUrlCartBottomBarSelector from 'containers/CartBottomBar/selectors/get-url'
// import isInGiftingModeSelect from 'modules/gift/redux/selectors/is-in-gifting-mode'
import hasSampleCartSelect from 'modules/cart/redux/selectors/has-sample'
import hasGiftCardCartSelect from 'modules/cart/redux/selectors/has-gift-card'
import CartBottomBarViewCart from 'containers/CartBottomBar/components/ViewCart'
import getStepGiftSelect from 'modules/gift/redux/selectors/get-step'
import { GIFT_STEP } from 'modules/gift/redux/constants'
import updateStepGiftAction from 'modules/gift/redux/actions/update-step'
import getStepFromUrlGiftUtil from 'modules/gift/utils/get-step-from-url'
import getHrefLocationUtil from 'utils/location/get-href'
import runAfterDelayTimingUtil from 'utils/timing/run-after-delay'
import isSelfGiftingUrlLocationUtil from 'utils/location/is-self-gifting-url'
import isDisabledBottomBarButtonGiftSelector from 'containers/CartBottomBar/selectors/is-disabled'
import CartBottomBarContinueButton from 'containers/CartBottomBar/components/ContinueButton'
import isGiftOrSelfGiftingUrlLocationUtil from 'utils/location/is-gift-or-self-gifting'
import Flex from 'components/Flex'
import ExpressCheckoutButton from 'containers/CartBottomBar/components/ExpressCheckoutButton'
import hasExpressCheckoutCartSelect from 'modules/cart/redux/selectors/has-express-checkout'
import isFullSizeFirstFlowGiftUtil from 'modules/gift/utils/is-full-size-first-flow'
// import isSelectingFreeBonusSamplesFlowTypeUtil from 'modules/gift/utils/is-add-sample-flow-type'
import isHomeUrlLocationUtil from 'utils/location/is-home-url'
import hasItemsCartSelect from 'modules/cart/redux/selectors/has-items-cart'
import isFilterSheetVisibleProductSelect from 'modules/product/redux/selectors/is-filter-sheet-visible'
import isCollectionUrlLocationUtil from 'utils/location/is-collection'

const isSelfGifting = isSelfGiftingUrlLocationUtil()

// const SCROLL_THROTTLE_DELAY_IN_MS = 300
// const VISIBLE_Y_OFFSET_DESKTOP = 300
// const VISIBLE_Y_OFFSET_MOBILE = 500

export default function CartBottomBar (props) {
  const isGifting = isGiftOrSelfGiftingUrlLocationUtil()
  const isMediumScreen = useIsMediumScreen()
  const isInformationValid = useSelector(isInformationValidGiftSelect)
  const hasSample = useSelector(hasSampleCartSelect)
  const hasGiftCard = useSelector(hasGiftCardCartSelect)
  const step = useSelector(getStepGiftSelect)
  const dispatch = useDispatch()
  // const isSelectSampleStep = step === GIFT_STEP.SELECT_SAMPLES
  const stepRef = React.useRef(step)
  const isFullSizeFirstFlow = isFullSizeFirstFlowGiftUtil()
  const isHomeUrl = isHomeUrlLocationUtil()

  const hasItemsCart = useSelector(hasItemsCartSelect)
  const isFilterSheetVisible = useSelector(isFilterSheetVisibleProductSelect)
  const isCollectionUrl = isCollectionUrlLocationUtil()

  // const isSelectingFreeBonusSamplesFlow = isSelectingFreeBonusSamplesFlowTypeUtil()

  // const isVisibleProp = (
  //   isMediumScreen ||
  //   !isSelectSampleStep ||
  //   !isGifting ||
  //   isFullSizeFirstFlow ||
  //   isSelectingFreeBonusSamplesFlow
  // )
  // const [isVisible, setIsVisible] = React.useState(isVisibleProp)
  const [isVisible, setIsVisible] = React.useState(true)
  const hasExpressCheckout = useSelector(hasExpressCheckoutCartSelect)

  let startLabelCTA
  const { onClickStart } = props
  if (
    onClickStart &&
    isMediumScreen &&
    !hasGiftCard &&
    isGifting &&
    !isFullSizeFirstFlow &&
    !isSelfGifting
  ) {
    // startLabelCTA = CTA
  }
  const [startLabel, setStartLabel] = React.useState(startLabelCTA)

  const isDisabled = useSelector(
    isDisabledBottomBarButtonGiftSelector({ startLabel })
  )
  const buttonUrl = useSelector(
    getUrlCartBottomBarSelector({
      startLabel,
      isDisabled
    })
  )
  const ref = React.useRef()
  const parentRef = React.useRef()
  const hasAddedAGiftCardRef = React.useRef()

  const debugProps = {
    isMediumScreen,
    isInformationValid,
    isVisible,
    hasSample,
    hasGiftCard,
    buttonUrl,
    hasAddedAGiftCardRef,
    step,
    startLabel,
    isDisabled,
    hasItemsCart,
    props,
    isFilterSheetVisible,
    hasExpressCheckout
  }
  logUtil('CartBottomBar').debug('[start] debugProps=', debugProps)
  //
  // const handleScroll = () => {
  //   const yOffset = getYOffsetDomUtil()
  //   const isSelectSampleStep = stepRef.current === GIFT_STEP.SELECT_SAMPLES
  //   const debugProps = {
  //     yOffset,
  //     stepRef,
  //     isSelectSampleStep
  //   }
  //
  //   logUtil('CartBottomBar#handleScroll').debug('[start] handleScroll=', debugProps)
  //
  //   if (isFullSizeFirstFlow) {
  //     logUtil('CartBottomBar#handleScroll').debug('[noop] full size first')
  //     return
  //   }
  //
  //   if (
  //     (
  //       isSelectSampleStep ||
  //       isSelectingFreeBonusSamplesFlow
  //     ) &&
  //     !isMediumScreen &&
  //     yOffset < VISIBLE_Y_OFFSET_DESKTOP
  //   ) {
  //     logUtil('CartBottomBar#handleScroll').debug('not visible')
  //     setIsVisible(false)
  //   }
  //
  //   if (
  //     (
  //       isSelectSampleStep ||
  //       isSelectingFreeBonusSamplesFlow
  //     ) &&
  //     !isMediumScreen &&
  //     yOffset >= VISIBLE_Y_OFFSET_DESKTOP) {
  //     logUtil('CartBottomBar#handleScroll').debug('set visible')
  //     setIsVisible(true)
  //   }
  //
  //   if (
  //     isMediumScreen &&
  //     yOffset >= VISIBLE_Y_OFFSET_MOBILE &&
  //     startLabel
  //   ) {
  //     logUtil('CartBottomBar#handleScroll').debug('remove start label')
  //     setStartLabel(null)
  //   }
  // }
  //
  // const throttledScrollRef = React.useRef(
  //   throttle(handleScroll, SCROLL_THROTTLE_DELAY_IN_MS)
  // )

  React.useEffect(() => {
    if (
      !isGifting &&
      !hasItemsCart
    ) {
      setIsVisible(false)
    }

    if (
      !isGifting &&
      hasItemsCart
    ) {
      setIsVisible(true)
    }
  }, [hasItemsCart])

  const changePosition = async ({ isMediumScreen }) => {
    if (!parentRef.current && ref.current) {
      parentRef.current = ref.current.parentNode
    }

    await runAfterDelayTimingUtil()
    handleResizePositionFixedComponentUtil({
      ref,
      isInsideParent: isMediumScreen,
      parentRef
    })
  }

  React.useEffect(() => {
    // Shows an error when filters are applied but not products are shown
    // @see {@link https://goairshop.atlassian.net/browse/AS-1739}
    if (isCollectionUrl) {
      return
    }

    // Not changing position otherwise it gets hidden
    if (
      isHomeUrl
    ) {
      changePosition({
        isMediumScreen: false
      })
      return
    }

    changePosition({ isMediumScreen })
  }, [isMediumScreen])

  React.useEffect(() => {
    stepRef.current = step
  }, [step])

  React.useEffect(() => {
    const step = getStepFromUrlGiftUtil(getHrefLocationUtil())
    const debugProps = { step }
    logUtil('CartBottomBar#mount').debug('debugProps=', debugProps)
    if (step) {
      dispatch(
        updateStepGiftAction(step)
      )
    }

    if (
      step &&
      step !== GIFT_STEP.SELECT_SAMPLES
    ) {
      setStartLabel(null)
    }

    function locationHashChanged (e) {
      const newUrl = e.newURL
      const debugProps = { newUrl }
      logUtil('CartBottomBar#locationHashChanged').debug('debugProps=', debugProps)
      const step = getStepFromUrlGiftUtil(newUrl)
      if (!step) {
        return
      }
      dispatch(updateStepGiftAction(step))
    }

    window.onhashchange = locationHashChanged

    // isGifting && document.addEventListener('scroll', throttledScrollRef.current)
    return () => {
      // isGifting && document.removeEventListener('scroll', throttledScrollRef.current)
    }
  }, [])

  return (
    <View
      className={
        classNames({
          'cart-bottom-bar': true,
          'cart-bottom-bar_visible': isVisible,
          'cart-bottom-bar_hidden': isFilterSheetVisible,
          'cart-bottom-bar_express-checkout': hasExpressCheckout
        })
      }
      ref={ref}
    >
      {
        !startLabel && (
          <CartBottomBarViewCart />
        )
      }

      <Flex className='cart-bottom-bar-buttons'>
        <CartBottomBarContinueButton />

        {
          !startLabel &&
          hasExpressCheckout && (
            <ExpressCheckoutButton />
          )
        }
      </Flex>
    </View>
  )
}
